/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  AddDeploymentPackageForm,
  AddDeploymentPackageForm$Outbound,
  AddDeploymentPackageForm$outboundSchema,
} from "./adddeploymentpackageform.js";
import {
  AddExternalMCPForm,
  AddExternalMCPForm$Outbound,
  AddExternalMCPForm$outboundSchema,
} from "./addexternalmcpform.js";
import {
  AddFunctionsForm,
  AddFunctionsForm$Outbound,
  AddFunctionsForm$outboundSchema,
} from "./addfunctionsform.js";
import {
  AddOpenAPIv3DeploymentAssetForm,
  AddOpenAPIv3DeploymentAssetForm$Outbound,
  AddOpenAPIv3DeploymentAssetForm$outboundSchema,
} from "./addopenapiv3deploymentassetform.js";

export type CreateDeploymentRequestBody = {
  /**
   * The external ID to refer to the deployment. This can be a git commit hash for example.
   */
  externalId?: string | undefined;
  externalMcps?: Array<AddExternalMCPForm> | undefined;
  /**
   * The upstream URL a deployment can refer to. This can be a github url to a commit hash or pull request.
   */
  externalUrl?: string | undefined;
  functions?: Array<AddFunctionsForm> | undefined;
  /**
   * The github pull request that resulted in the deployment.
   */
  githubPr?: string | undefined;
  /**
   * The github repository in the form of "owner/repo".
   */
  githubRepo?: string | undefined;
  /**
   * The commit hash that triggered the deployment.
   */
  githubSha?: string | undefined;
  /**
   * If true, the deployment will be created in non-blocking mode where the request will return immediately and the deployment will proceed asynchronously.
   */
  nonBlocking?: boolean | undefined;
  openapiv3Assets?: Array<AddOpenAPIv3DeploymentAssetForm> | undefined;
  packages?: Array<AddDeploymentPackageForm> | undefined;
};

/** @internal */
export type CreateDeploymentRequestBody$Outbound = {
  external_id?: string | undefined;
  external_mcps?: Array<AddExternalMCPForm$Outbound> | undefined;
  external_url?: string | undefined;
  functions?: Array<AddFunctionsForm$Outbound> | undefined;
  github_pr?: string | undefined;
  github_repo?: string | undefined;
  github_sha?: string | undefined;
  non_blocking?: boolean | undefined;
  openapiv3_assets?:
    | Array<AddOpenAPIv3DeploymentAssetForm$Outbound>
    | undefined;
  packages?: Array<AddDeploymentPackageForm$Outbound> | undefined;
};

/** @internal */
export const CreateDeploymentRequestBody$outboundSchema: z.ZodMiniType<
  CreateDeploymentRequestBody$Outbound,
  CreateDeploymentRequestBody
> = z.pipe(
  z.object({
    externalId: z.optional(z.string()),
    externalMcps: z.optional(z.array(AddExternalMCPForm$outboundSchema)),
    externalUrl: z.optional(z.string()),
    functions: z.optional(z.array(AddFunctionsForm$outboundSchema)),
    githubPr: z.optional(z.string()),
    githubRepo: z.optional(z.string()),
    githubSha: z.optional(z.string()),
    nonBlocking: z.optional(z.boolean()),
    openapiv3Assets: z.optional(
      z.array(AddOpenAPIv3DeploymentAssetForm$outboundSchema),
    ),
    packages: z.optional(z.array(AddDeploymentPackageForm$outboundSchema)),
  }),
  z.transform((v) => {
    return remap$(v, {
      externalId: "external_id",
      externalMcps: "external_mcps",
      externalUrl: "external_url",
      githubPr: "github_pr",
      githubRepo: "github_repo",
      githubSha: "github_sha",
      nonBlocking: "non_blocking",
      openapiv3Assets: "openapiv3_assets",
    });
  }),
);

export function createDeploymentRequestBodyToJSON(
  createDeploymentRequestBody: CreateDeploymentRequestBody,
): string {
  return JSON.stringify(
    CreateDeploymentRequestBody$outboundSchema.parse(
      createDeploymentRequestBody,
    ),
  );
}
